<template>
  <div id="sequence_linkedin_analytics" class="flex flex-col gap-2">
    <LinkedinAnalyticsGrid />
    <LinkedinActivityGraph />
  </div>
</template>

<script setup>
import LinkedinActivityGraph from "@/src/views/analytics/v2/sequence_analytics/linkedin/LinkedinActivityGraph.vue";
import LinkedinAnalyticsGrid from "@/src/views/analytics/v2/sequence_analytics/linkedin/LinkedinAnalyticsGrid.vue";
</script>
